import React from 'react';
import { IconButton } from '@mui/material';
import { ExportIcon } from '../../icons';
import { ExportDialogRenderProps } from './ExportDialogRenderProps';
export const ExportButtonWithDialog = ({ disabled, iconProps, title, iconDataCy = 'export-icon', ...props }) => {
    return (React.createElement(ExportDialogRenderProps, { ...props }, ({ handleOpenExport }) => (React.createElement(IconButton, { ...iconProps, disabled: disabled, title: title, "data-cy": iconDataCy, onClick: handleOpenExport, size: "large" },
        React.createElement(ExportIcon, null)))));
};
export default ExportButtonWithDialog;
